"use client"

import { AI_ROLE_TYPE } from '@/constants';
import { IModel } from '@/types';

export default function ModelIcon({ model, className }: { model: IModel, className: string }) {
  const img: Record<number, string> = {
    [AI_ROLE_TYPE.QWENMAX]: '/images/gpt/qianwen.jpg',
    [AI_ROLE_TYPE.SPARK]: '/images/gpt/xinghuo.jpg',
    [AI_ROLE_TYPE.WENXIN]: '/images/gpt/wenxin.jpg',
    [AI_ROLE_TYPE.WENXIN4]: '/images/gpt/wenxin.jpg',
    [AI_ROLE_TYPE.WENKEAI3]: '/images/gpt/wenkoo.jpg',
    [AI_ROLE_TYPE.WENKEAI4]: '/images/gpt/wenkoo.jpg',
    [AI_ROLE_TYPE.KIMI]: '/images/gpt/kimi.jpg',
    [AI_ROLE_TYPE.YIGE]: '/images/gpt/wenxin.jpg',
    [AI_ROLE_TYPE.DEEPSEEKV3]: '/images/gpt/deepseek.png',
    [AI_ROLE_TYPE.DEEPSEEKR1]: '/images/gpt/deepseek.png',
    [AI_ROLE_TYPE.HUNYUAN]: '/images/gpt/hunyuan.jpg',
    [AI_ROLE_TYPE.HUNYUANS]: '/images/gpt/hunyuan.jpg',
  };

  return (
    <img className={className} src={img[model?.id || AI_ROLE_TYPE.WENKEAI3]} />
  )
}
